import React from 'react';
import "./index.scss";
import { SelectStyles } from './SelectStyles';
import Select from 'react-select';
import { Country, City } from 'country-state-city';
import InputRange from 'react-input-range';
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-input-range/lib/css/index.css";

const DestinationFilter = ({ filters, setFilters, defaultPaginate }) => {
    const countryList = Country.getAllCountries().map((country) => ({
        label: country.name,
        value: country.name,
        ...country
    }));

    const updatedCity = City.getCitiesOfCountry(filters.country.isoCode).map((city) => ({
        label: city.name,
        value: city.name,
        ...city
    }));

    const handleCountryChange = async (country) => {
        if (country) {
            setFilters((prev) => ({
                ...prev,
                country: country,
                city: [],
            }));
        } else {
            setFilters((prev) => ({
                ...prev,
                country: "",
                city: [],
            }));
        }
        defaultPaginate();
    };
    const handleCityChange = async (data) => {
        const updatedCities = data ? data : [];
        setFilters((prev) => ({
            ...prev,
            city: updatedCities,
        }));
        defaultPaginate();
    };


    return (
        <div className="row">
            <div className="col-md-6">
                <Select
                    value={filters.country}
                    placeholder={"Search country"}
                    options={countryList}
                    onChange={handleCountryChange}
                    isClearable={true}
                    styles={{ ...SelectStyles }}
                />
            </div>
            <div className="col-md-6 mt-3 mt-md-0">
                <Select
                    value={filters.city}
                    placeholder={"Search city"}
                    options={updatedCity}
                    onChange={handleCityChange}
                    isClearable={true}
                    // isLoading={true}
                    isMulti
                    styles={{ ...SelectStyles }}
                />
            </div>
        </div>
    );
};

const DateRangeFilter = ({ filters, setFilters, defaultPaginate }) => {

    const handleDateFilter = (date) => {
        if (date?.selection) {
            setFilters((prev) => ({
                ...prev,
                dateRange: {
                    startDate: date?.selection?.startDate,
                    endDate: date?.selection?.endDate,
                    key: 'selection',
                    status: true
                }
            }));
        }
        defaultPaginate();
    }

    return (
        <div className='date-range-bx'>
        <DateRange
            editableDateInputs={true}
            onChange={handleDateFilter}
            moveRangeOnFirstSelection={false}
            ranges={[filters.dateRange]}
            rangeColors={["#004aad"]}
        />
        </div>
    );
};

const DaysFilter = ({ filters, setFilters, defaultPaginate }) => {
    const handleDaysFilterComplete = (value) => {
        if (value) {
            setFilters((prev) => ({
                ...prev,
                dayRange: value
            }));
        }
        defaultPaginate();
    }
    return (
        <div className="custom-range-slider">
            <InputRange
                step={1}
                formatLabel={value => `${value} Days`}
                // formatLabel={value => null}
                draggableTrack={true}
                allowSameValues={false}
                value={filters.dayRange}
                minValue={1}
                maxValue={60}
                onChange={value => {
                    setFilters((prev) => ({
                        ...prev,
                        dayRange: value
                    }));
                }}
                onChangeComplete={value => handleDaysFilterComplete(value)}
            />
            {/* 
            <div className="pricerange-minmax">
                <span>{filters.dayRange.min} Days</span>
                <span>{filters.dayRange.max} Days</span>
            </div> 
            */}
        </div>
    );
};

const CostFilter = ({ filters, setFilters, defaultPaginate, currencyData, defaultMaxPrice }) => {
    const handlePriceFilterComplete = (value) => {
        setFilters((prev) => ({
            ...prev,
            priceRange: value
        }));
        defaultPaginate();
    };
    return (
        <div className="custom-range-slider">
            <InputRange
                step={1}
                formatLabel={value => `${value} ${currencyData?.currency}`}
                //formatLabel={value => null}
                draggableTrack={false}
                allowSameValues={false}
                minValue={1}
                maxValue={Number(defaultMaxPrice)}
                value={filters.priceRange}
                onChange={value =>
                    setFilters((prev) => ({
                        ...prev,
                        priceRange: value
                    }))
                }
                onChangeComplete={value => handlePriceFilterComplete(value)}
            />
        </div>
    );
};

const RatingsFilter = ({ filters, setFilters, ratingTypes, ratingRef, defaultPaginate }) => {
    const handleTravellerRatingChange = (event) => {
        setFilters((prev) => {
            const { travellerRating } = prev;
            const updatedTravellerRating = event.target.checked
                ? [...new Set([...travellerRating, event.target.value])]
                : travellerRating.filter((type) => type !== event.target.value);

            return {
                ...prev,
                travellerRating: updatedTravellerRating,
            };
        });
        defaultPaginate();
    };

    return (
        <ul className="filter-list-ul">
            {ratingTypes.map((rating, index) => (
                <li key={rating}>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            value={rating}
                            ref={(element) => ratingRef.current[index] = element}
                            onChange={handleTravellerRatingChange}
                            className="form-check-input"
                            id={`Rating${rating}`}
                            checked={filters.travellerRating.includes(rating.toString())}
                        />
                        <label className="form-check-label rating-filter" htmlFor={`Rating${rating}`}>
                            {Array.from({ length: 5 }).map((_, i) => (
                                <i
                                    key={i}
                                    className={i < 5 - index ? "bi bi-star-fill" : "bi bi-star"}
                                ></i>
                            ))}
                            {rating != 5 && <span>& up</span>}
                        </label>
                    </div>
                </li>
            ))}
        </ul>
    );
};

const TravellerFilter = ({ filters, setFilters, travellerTypes, travellersRef, defaultPaginate }) => {
    const handleTravellerTypeChange = (event) => {
        setFilters((prev) => {
            const { travellerType } = prev;
            const updatedTravellerType = event.target.checked
                ? [...new Set([...travellerType, event.target.value])]
                : travellerType.filter((type) => type !== event.target.value);

            return {
                ...prev,
                travellerType: updatedTravellerType,
            };
        });
        defaultPaginate();
    };

    return (
        <ul className="filter-list-ul">
            {travellerTypes.map((type, index) => (
                <li key={type}>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            value={type}
                            ref={(element) => travellersRef.current[index] = element}
                            onChange={handleTravellerTypeChange}
                            className="form-check-input"
                            id={`Traveller${type}`}
                            checked={filters.travellerType.includes(type)}
                        />
                        <label className="form-check-label" htmlFor={`Traveller${type}`}>
                            {type}
                        </label>
                    </div>
                </li>
            ))}
        </ul>
    );
};

const SortingFilter = ({ filters, setFilters, sortingTypes }) => {
    const handleSortingChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            sortType: e.target.value,
        }));
    };

    return (
        <ul className="filter-list-ul">
            {sortingTypes.map((type, index) => (
                <li key={type}>
                    <div className="form-check">
                        <input
                            type="radio"
                            value={type}
                            onChange={handleSortingChange}
                            className="form-check-input"
                            id={`Sorting${type}`}
                            checked={filters.sortType.includes(type)}
                        />
                        <label className="form-check-label" htmlFor={`Sorting${type}`}>
                            {type}
                        </label>
                    </div>
                </li>
            ))}
        </ul>
    );
};


export {
    DestinationFilter,
    DaysFilter,
    CostFilter,
    RatingsFilter,
    TravellerFilter,
    DateRangeFilter,
    SortingFilter
};